export default {
  route: {
    home: 'home',
    profile: 'Profile',
    product: 'product',
    productOnlineManage: 'productOnlineManage',
    productUnderManage: 'productUnderManage',
    seller: 'seller',
    sellerList: 'sellerList',
    sellerApprove: 'sellerApprove',
    sellerSubordinate: 'sellerSubordinate',
    sellerRelation: 'sellerRelation',
    liveBroadcast: 'liveBroadcast',
    socialGroup: 'socialGroup',
    socialGroupDynamic: 'socialGroupDynamicList',
    memberManage: 'memberManage',
    memberList: 'memberList',
    memberDetail:'memberDetail',
    memberPoint: 'memberPoint',
    memberAuthentica: 'memberAuthentica',
    memberAuditDetail:'memberAuditDetail',
    manageType: 'manageType',
    reportConfig: 'reportConfig',
    assetManage: 'assetManage',
    settleManage: 'settleManage',
    staBalance:'staBalance',
    staSettle:'staSettle',
    reconciManage: 'reconciManage',
    billManage: 'billManage',
    withdrawManage: 'withdrawManage',
    userRechargeOrder: 'userRechargeOrder',
    userCashTopUp: 'userCashTopUp',
    reportDownload: 'reportDownload',
    summaryManagement:'summaryManagement',
    topUpOrderCancel:'topUpOrderCancel',
    redRush: 'redRush',
    reductionManage: 'reductionManage',
    withdrawMonitor: 'withdrawMonitor',
    marketingManage: 'marketingManage',
    activityList: 'activityList',
    activityAuditList: 'activityAuditList',
    redpacketList: 'redpacketList',
    redpacketAuditList: 'redpacketAuditList',
    redpacketTrackList: 'redpacketTrackList',
    couponsList: 'couponsList',
    couponsAuditList: 'couponsAuditList',
    couponsTrackList: 'couponsTrackList',
    issueList: 'issueList',
    issueAuditList: 'issueAuditList',
    shortActivity: 'shortActivity',
    summaryData: 'summaryData',
    blackList: 'blackList',
    priceContrast: 'priceContrast',
    couponList:'couponList',
    addCoupon:'addCoupon',
    couponActivity:'couponActivity',
    addActivity:'addActivity',
    editActivity:'editActivity',
    drawCouponList:'drawCouponList',
    marketingFee:'marketingFee',
    category: 'categoryManage',
    sysCategory: 'sysCategory',
    virtualCategory: 'virtualCategory',
    sys: 'SysManage',
    menuList: 'menuList',
    roleList: 'roleManage',
    adminList: 'adminManage',
    configManage: 'configManage',
    config: 'configManage',
    configList: 'configList',
    logistics: 'logisticsManage',
    specialCommoditySettlement: 'specialCommoditySettlement',
    whiteList: 'whiteList',
    msgList: 'msgList',
    delayList: 'delayList',
    afterWhyList: 'afterWhyList',
    warehouse: 'warehouse',
    businessConfig: 'businessConfig',
    faqList: 'faqManage',
    searchList: 'searchList',
    agreementList: 'agreementList',
    reprintReason: 'reprintReason',
    purchaseConfig: 'purchaseConfig',
    sundry: 'sundry',
    placeList: 'placeAreaManage',
    accountList: 'accountManage',
    aftersale: 'aftersale',
    aftersaleOrder: 'aftersaleOrder',
    refundOrder: 'refundOrder',
    orderManage: 'orderManage',
    cityWholesalerOrder: 'cityWholesalerOrder',
    originDealerOrder: 'originDealerOrder',
    pageConfig: 'pageConfig',
    floorConfig: 'floorConfig',
    advertConfig: 'advertConfig',
    goodsRecommend: 'goodsRecommend',
    informationList: 'informationList',
    logisticsDelivery:'logisticsDelivery',
    transferDistribution:'transferDistribution',
    logisticsOrderManag:'logisticsOrderManag',
    freightManage: 'freightManage',
    scanIndex:'scanIndex',
    businessCircleNews:'businessCircleNews',
    clientManage: 'clientManage',
    relationManage: 'relationManage',
    promoterManage: 'promoterManage',
    businessManager:'businessManager',
    business:'business',
    lsManager:'lsManager',
    councilManager:'councilManager',
    purchaseHelper: 'purchaseHelper',
    purchaseCategory: 'purchaseCategory',
    purchaseRecommend: 'purchaseRecommend',
    purchaseSummary: 'purchaseSummary',
    unrecordedSummary: 'unrecordedSummary',
    quotationManage: 'quotationManage',
    productDraft:'productDraft',
    reportList:'reportList',
    superMember:'superMember',
    blackListMember:'blackListMember',
    superMemberShang:'superMemberShang',
    finance:"finance",
    posWithdraw:"posWithdraw",
    dailySales:"dailySales",
    withdrawalIncidental:'withdrawalIncidental',
    financeLogistics:'financeLogistics',
    financeLogisticsDetail:'financeLogisticsDetail',
    fund:'fund',
    fundDaily:'fundDaily',
    capitalDaily:'capitalDaily',
    shopDaily:'shopDaily',
    categorySum:'categorySum',
    serviceRate:'serviceRate',
    productSales:'productSales',
    shopWithdrawalSum:'shopWithdrawalSum',
    productWithdrawalSum:'productWithdrawalSum',
    productWithdrawalDetail:'productWithdrawalDetail',
    thermodynamicDiagram:"thermodynamicDiagram",
    thermData:"thermData",
    marketingExpenseBill: "marketingExpenseBill",
    tripartiteBiz: 'tripartiteBiz',
    tripartiteOrder: 'tripartiteOrder',
    tripartiteTeam: 'tripartiteTeam',
    tripartiteFreight: 'tripartiteFreight',
    visitManage: 'visitManage',
    workOrderManage: 'workOrderManage',
  },
  navbar: {
    welcome: 'Welcome',
    home: 'Welcome',
    logOut: 'Log Out',
    profile: 'Profile'
  },
  login: {
    title: 'Login Form',
    logIn: 'Login',
    account: 'Account',
    password: 'Password',
    any: 'any',
    thirdparty: 'Or connect with',
    thirdpartyTips: 'Can not be simulated on local, so please combine you own business simulation! ! !'
  },
  table: {
    add: 'add',
    audit: 'audit',
    bind: 'bind',
    cancel: 'cancel',
    confirm: 'confirm',
    draft: 'draft',
    delete: 'delete',
    disable: 'disable',
    detail: 'detail',
    export: 'export',
    edit: 'edit',
    enable: 'enable',
    import: 'import',
    list: 'search',
    reset: 'reset',
    update: 'update'
  },
  permsbtns: {
    add: 'add',
    create: 'create',
    update: 'update',
    list: 'list',
    query: 'query',
    disable: 'disable',
    enable: 'enable',
    audit: 'audit',
    delete: 'delete',
    detail: 'detail',
    import: 'import',
    modify: 'modify',
    move: 'move',
    enabled: 'enabled',
    withdraw: 'withdraw',
    confirm: 'confirm',
    export: 'export',
    endlivebroadcast: 'endlivebroadcast',
    look: 'look',
    enableDisable: 'enableDisable',
    trendDisable: 'trendDisable',
    submit: 'submit',
    trace: 'trace',
    defriend: 'defriend',
    restpwd: 'restpwd',
    addType: 'addType',
    addWen: 'addWen',
    indexFoorConfig: 'indexFoorConfig',
    addTag: 'addTag',
    drop: 'drop',
    release: 'release',
    accessDeal: 'accessDeal',
    charge: 'charge',
    channellist: 'channellist',
    updatePhone: 'updatePhone',
    pwd: 'pwd',
    auth: 'auth',
    card: 'card',
    bind: 'bind',
    unbind: 'unbind',
    publish: 'publish',
    unpublish: 'unpublish',
    close: 'close',
    redRush: 'redRush',
    execManual: 'execManual',
    maintainScale: 'maintainScale',
    shopList: 'shopList',
    platformList: 'platformList',
    auditList: 'auditList',
    shopExport: 'shopExport',
    platformExport: 'platformExport',
    listExport: 'listExport',
    blackListImport: 'blackListImport',
    blackListExport: 'blackListExport',
    start:'start',
    confirms:'confirms',
    typeDelete:'typeDelete',
    typeAdd:'typeAdd',
    migratel:'migratel',
    reverse:'reverse',
    print: "print",
    send: 'send',
    changeDriver: 'changeDriver',
    printSendList: 'printSendList',
    reductionJcAuth: 'reductionJcAuth',
    reductionCwOperate: 'reductionCwOperate',
    secKillDisable: 'secKillDisable',
    secKillAdd: 'secKillAdd',
    secKillUpdate: 'secKillUpdate',
    secKillEnable: 'secKillEnable',
    secKillDrop: 'secKillDrop',
  },
  errorLog: {
    tips: 'Please click the bug icon in the upper right corner',
    description: 'Now the management system are basically the form of the spa, it enhances the user experience, but it also increases the possibility of page problems, a small negligence may lead to the entire page deadlock. Fortunately Vue provides a way to catch handling exceptions, where you can handle errors or report exceptions.',
    documentation: 'Document introduction'
  },
  tagsView: {
    refresh: 'Refresh',
    close: 'Close',
    closeOthers: 'Close Others',
    closeAll: 'Close All'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js